<template>
  <div class="flex-1 pt-40 min-w-100 max-w-135 mx-auto flex flex-col gap-4">
    <h1 class="text-4xl font-600">
      {{t('pages.resetPassword.forgot_password')}}
    </h1>
    <p class="text-sm">
      {{t('pages.resetPassword.forgot_password_tip')}}
    </p>
    <t-form
      :label-width="0"
      :rules="FORM_RULES"
      :data="formData"
      ref="emailForm"
    >
      <t-form-item name="email">
        <t-input
          v-model="formData.email"
          clearable
          :placeholder="t('global.email')"
        >
          <template #prefix-icon>
            <icon-login-email />
          </template>
        </t-input>
      </t-form-item>
    </t-form>
    <t-button
      theme="primary"
      type="submit"
      block
      @click="handleSendEmail"
      class="mt-2"
      :loading="sendLoading"
    >
      {{t('pages.resetPassword.send_email')}}
    </t-button>
    <t-dialog
      v-model:visible="showDialog"
      :close-btn="false"
      :header="sendStatus==='success'?t('pages.resetPassword.tip.send_email_success_title',{
        email:formData.email
      }):t('pages.resetPassword.tip.send_email_error')"
      :cancel-btn="null"
      :body="sendStatus==='success'?t('pages.resetPassword.tip.send_email_success_content'):''"
      :theme="sendStatus==='success'?'success':'warning'"
      :confirmBtn="t('global.ok')"
      @confirm="handleConfirm"
    >
    </t-dialog>
  </div>
</template>
<script setup lang='ts'>
import type { FormProps } from 'tdesign-vue-next';
import { sendEmail } from '@/api/modules/resetPassword';
definePage({
  meta: {
    layout: "login-layout"
  },
})
const{t,locale}=useI18n()
const router=useRouter()
const showDialog=ref(false)
const sendStatus=ref<null | 'success' | 'error'>(null)
const formData: FormProps['data'] = ref({
  email: '',
});
const sendLoading=ref(false)
const emailForm=ref()
watch(()=>locale.value, ()=>{
    emailForm.value.clearValidate();
})
const FORM_RULES: FormProps['rules'] = {
  email: [
    {
      required: true,
      message: t('global.form.verifyError.input.empty_error',{
        'field_name':t('global.email')
      }),
    },
    {
      email: { ignore_max_length: true },
      message: t('global.form.verifyError.email.format_error'),
      type: 'error',
    },
  ],
};
const handleSendEmail=async()=>{
  const validate = await emailForm.value.validate();

  if (validate !== true) return;
  sendLoading.value=true
    sendEmail({
        email:formData.value.email

    }).then(res=>{
        showDialog.value=true
        sendStatus.value='success'
    }).catch(e=>{
      showDialog.value=true
       sendStatus.value='error'
    }).finally(()=>{
      sendLoading.value=false

    })
}
const handleConfirm=()=>{
  if(sendStatus.value==='success'){
    router.push('/login')
  }
  showDialog.value=false
  sendStatus.value=null

}
onMounted(()=>{
})
</script>
<style scoped >
  :deep(.t-dialog--default){
    @apply p-6
  }
  :deep(.t-dialog__body__icon){
    @apply py-2 pl-8
  }
</style>
